import { Component } from '@angular/core';
import { BaseDialogComponent } from '@shared/library/components/base-dialog/base-dialog.component';
import { TypeDialogEnum } from '@shared/library/configs/enums/type-dialog-enum';

@Component({
  selector: 'app-info-dialog',
  imports: [BaseDialogComponent],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss'
})
export class InfoDialogComponent {
  public type: TypeDialogEnum = TypeDialogEnum.INFO;
}
